import { Button, TextArea } from 'components/core';
import { AGG_TEMPLATES, AGG_TYPES, blankNode } from 'helpers/kpiBuilder/advanced';
import { AggNode } from 'helpers/kpiBuilder/types';
import { OptionChips } from './OptionChips';
import { TextBox } from './TextBox';
import { OUTLINE_SMALL } from './buttonProps';

interface AggNodeEditorProps {
  node: AggNode;
  onChange: (next: AggNode) => void;
  onRemove: () => void;
}


const isUntouched = (body: string): boolean => body.trim() === '' || body.trim() === '{}' || Object.values(AGG_TEMPLATES).includes(body);

// One aggregation: a name, a type, the JSON of its settings, and the aggregations inside it. Any type Elasticsearch has can be typed.
export const AggNodeEditor = ({ node, onChange, onRemove }: AggNodeEditorProps) => {
  const setChild = (i: number, next: AggNode) => onChange({ ...node, children: node.children.map((c, j) => (j === i ? next : c)) });
  const chooseType = (type: string) => onChange({ ...node, type, body: isUntouched(node.body) ? AGG_TEMPLATES[type] ?? '{}' : node.body });

  return (
    <div className="border rounded p-2 mb-2 bg-white">
      <TextBox value={node.name} placeholder="Name, e.g. by_competency" onChange={(name) => onChange({ ...node, name })} />
      <div className="mt-2">
        <OptionChips options={AGG_TYPES.map((t) => ({ id: t, label: t }))} selected={[node.type]} onSelect={(id) => chooseType(String(id))} />
        <TextBox value={node.type} placeholder="Or type any other aggregation type" onChange={chooseType} />
      </div>
      <div className="mt-2">
        <TextArea showTitle={false} showDescription={false} rows={3} placeholder="Settings as JSON" value={node.body} onChange={(e: { target: { value: string } }) => onChange({ ...node, body: e.target.value })} />
      </div>
      {node.children.length > 0 && (
        <div className="ms-3 mt-2 border-start ps-2">
          {node.children.map((c, i) => (
            <AggNodeEditor key={i} node={c} onChange={(next) => setChild(i, next)} onRemove={() => onChange({ ...node, children: node.children.filter((_, j) => j !== i) })} />
          ))}
        </div>
      )}
      <div className="mt-2">
        <Button {...OUTLINE_SMALL} className="me-2" onClick={() => onChange({ ...node, children: [...node.children, blankNode()] })}>
          Add an aggregation inside
        </Button>
        <Button {...OUTLINE_SMALL} onClick={onRemove}>
          Remove this aggregation
        </Button>
      </div>
    </div>
  );
};
